import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Alert,
  FormGroup,
  Input,
} from 'reactstrap';
import moment from 'moment';

class AddRepairLogModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      repairLogDate: moment().format('YYYY-MM-DD'),
      errors: {},
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.show !== nextProps.show)
      this.setState({
        show: nextProps.show,
      });
  }

  createRepairLog = (event) => {
    event.preventDefault();
    const { repairLogDate } = this.state;
    if (!this.formIsValid) return;
    this.props.createRepairLog(repairLogDate);
    this.toggle();
  };

  formIsValid = () => {
    let errors = {};
    let isValid = true;
    if (this.state.repairLogDate === null || this.state.repairLogDate === '') {
      isValid = false;
      errors.dailyLogDate = 'Please select a date.';
    }
    this.setState({ errors: errors });
    return isValid;
  };

  toggle = () => {
    this.props.toggle();
  };

  render() {
    const { repairLogDate, show, errors } = this.state;
    const parsedDate = moment(repairLogDate).format('YYYY-MM-DD');
    return (
      <div>
        <Modal isOpen={show} toggle={this.toggle}>
          <ModalHeader>Select Log Date</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Input
                  type="date"
                  name="logDate"
                  id="logDate"
                  value={parsedDate}
                  onChange={(event) => {
                    this.setState({ repairLogDate: event.target.value });
                  }}
                />
                {errors.repairLogDate && (
                  <Alert className="mt-2 p-2" color={'danger'}>
                    {errors.repairLogDate}
                  </Alert>
                )}
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.createRepairLog}>
              Create Log
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default AddRepairLogModal;



// WEBPACK FOOTER //
// ./src/components/repair-log/AddRepairLogModal.js